import React, { useEffect, useRef, useState } from 'react';
import api from '../../api';
import './YoungApprenticeBenefitHolidayCalendar.css';

export default function YoungApprenticeBenefitHolidayCalendar({ reference, companyId }) {
  const year = Number(String(reference || '').split('/')[1]);
  const [companies, setCompanies] = useState([]);
  const [selected, setSelected] = useState('');
  const [calendar, setCalendar] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const request = useRef(0);
  useEffect(() => {
    let active = true;
    api.get('/student-management/young-apprentice/benefit-holidays').then(({ data }) => {
      if (active) { setCompanies(data.companies || []); setSelected(current => String(current || data.companies?.[0]?.id || '')); }
    }).catch(() => { if (active) setError('Não foi possível carregar as empresas do calendário.'); });
    return () => { active = false; };
  }, []);
  const effectiveCompany = companyId ? String(companyId) : selected;
  useEffect(() => {
    const id = ++request.current;
    setCalendar(null); setError(''); setLoading(false);
    if (!effectiveCompany || !Number.isInteger(year)) return;
    setLoading(true);
    api.get('/student-management/young-apprentice/benefit-holidays', { params: { companyId: Number(effectiveCompany), year } }).then(({ data }) => {
      if (id === request.current) setCalendar(data);
    }).catch(e => { if (id === request.current) setError(e?.response?.data?.error || 'Não foi possível carregar os feriados.'); })
      .finally(() => { if (id === request.current) setLoading(false); });
    return () => { request.current++; };
  }, [effectiveCompany, year]);
  return <details className="ya-benefit-holidays"><summary>Calendário de feriados</summary>
    <label>Empresa do calendário<select value={effectiveCompany} disabled={Boolean(companyId)} onChange={e => setSelected(e.target.value)}><option value="">Selecione</option>{companies.map(c => <option value={c.id} key={c.id}>{c.tradeName || c.corporateName}</option>)}</select></label>
    <p>Inclui feriados nacionais e feriados cadastrados aplicáveis à cidade/UF da empresa. Para alterar as datas, acesse Cadastros &gt; Feriados.</p>
    {error && <p role="alert">{error}</p>}{loading && <p role="status">Carregando feriados...</p>}
    {calendar && <>{calendar.locationIncomplete && <p role="status">Empresa com localização incompleta. Confira a cidade/UF no cadastro da empresa para aplicar os feriados locais; os feriados nacionais e gerais continuam disponíveis.</p>}<p>{calendar.location?.city}/{calendar.location?.state} · {year}</p><ul>{(calendar.holidays || []).map((day, index) => <li key={`${day.date}-${index}`}>{day.date.split('-').reverse().join('/')} — {day.name} ({day.source})</li>)}</ul></>}
  </details>;
}
